import React, { useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

import "./stylesLocationRestrictionsPopup.css";
import { Save, X } from "react-feather";
import SaveButton from "../../CommonComponents/SaveButton/SaveButton";

function LocationRestrictionsPopup({
  isVisible,
  onClosePressed,
  getEventCodesList,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const email = JSON.parse(localStorage.getItem("email"));

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maxChars = 50; // Máximo de caracteres permitidos

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    console.log("comment", comment);

    return;

    try {
      const params = { event_code: comment, created_by: email };
    } catch (error) {
      console.log("Error adding event code:", error);
    } finally {
      setIsSubmitting(false);
      setComment("");

      onClosePressed();
      await getEventCodesList();
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
    setComment("");
  };

  const handleSetComment = (value) => {
    if (value.length <= maxChars) {
      setComment(value);
    }
  };

  if (!isVisible) return null;
  return (
    <div className="location-restrictions-popup">
      <div className="location-restrictions-panel">
        <div className="location-restrictions-panel-header">
          <h2>Disable the location?</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <p>
            Make sure the decision is correct and describe the reason for it
          </p>
          <div className="event-code-input">
            <label htmlFor="eventCode">Add note</label>
            <textarea
              id="eventCode"
              value={comment}
              placeholder="Leave a comment"
              onChange={(e) => handleSetComment(e.target.value)}
              rows="3"
              required
            />
            <div className="comment-counter">
              {comment.length}/{maxChars}
            </div>
          </div>
          <SaveButton
            isSubmitting={isSubmitting}
            buttonText="Yes, Disable"
            cancelButton={true}
            cancelButtonText="No"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClosePressed}
          />
        </form>
      </div>
    </div>
  );
}

export default LocationRestrictionsPopup;
